module.exports = __webpack_public_path__ + "img/gift-01.467643f6.svg";